import { ZoButton } from '@zonofi/zo-components/input/zo-button/zo-button';
import React from 'react';
import { PNGS, SVGS } from '../assets';
import './splash-screen-phone.scss';
import { ZoInputText } from '../zo-input-text-temp/zo-input-text-temp';
import { useSplashScreenPhone } from './hooks/use-splash-screen-phone';
import { SwipeableDrawer } from '../swipeable-drawer/swipeable-drawer';
import { CountriesList } from '../countries-list/countries-list';
import { CountryObject, digitCounts } from '@zonofi/i18n';

interface SplashScreenProps {
  onUpdateValue?: (key: string, value: string | boolean) => void;
}

const SPLASH_SCREENS: {
  description: JSX.Element;
  heading: JSX.Element;
  imageUrl: string;
}[] = [
  {
    description: (
      <span className="splash-screen-phone-text-description primary-font-regular">
        Delivered directly through GenAI on WhatsApp{' '}
        <span className="line-break">
          <br />
        </span>{' '}
        for instant, personalised engagement.
      </span>
    ),
    heading: (
      <span className="splash-screen-phone-text-heading primary-font-bold">
        Achieve a 5–15% increase in{' '}
        <span className="line-break">
          <br />
        </span>{' '}
        attributable sales acceleration
      </span>
    ),
    imageUrl: PNGS.Splash1,
  },
  {
    description: (
      <span className="splash-screen-phone-text-description primary-font-regular">
        Using differentiated channel communication
      </span>
    ),
    heading: (
      <span className="splash-screen-phone-text-heading primary-font-bold">
        Increase reach to 1.5x - 2x{' '}
        <span className="line-break">
          <br />
        </span>{' '}
        customers with same salesforce
      </span>
    ),
    imageUrl: PNGS.Splash2,
  },
  {
    description: (
      <span className="splash-screen-phone-text-description primary-font-regular">
        Send bulk messages, use GenAI bot to{' '}
        <span className="line-break">
          <br />
        </span>{' '}
        respond on price, availability, scheme etc.
      </span>
    ),
    heading: (
      <span className="splash-screen-phone-text-heading primary-font-bold">
        Enable two-way{' '}
        <span className="line-break">
          <br />
        </span>{' '}
        conversation to collect 24X7 orders
      </span>
    ),
    imageUrl: PNGS.Splash3,
  },
  {
    description: (
      <span className="splash-screen-phone-text-description primary-font-regular">
        One Click sync with Tally/ ERPs to WhatsApp
      </span>
    ),
    heading: (
      <span className="splash-screen-phone-text-heading primary-font-bold">
        Send automated info on{' '}
        <span className="line-break">
          <br />
        </span>{' '}
        orders, invoices, payments, ledger
      </span>
    ),
    imageUrl: PNGS.Splash4,
  },
  {
    description: (
      <span className="splash-screen-phone-text-description primary-font-regular">
        For Zero Leakage schemes & targeted messaging
      </span>
    ),
    heading: (
      <span className="splash-screen-phone-text-heading primary-font-bold">
        Use Secondary{' '}
        <span className="line-break">
          <br />
        </span>{' '}
        Sales Data on WhatsApp
      </span>
    ),
    imageUrl: PNGS.Splash5,
  },
];

export const SplashScreenPhone: React.FC<SplashScreenProps> = ({
  onUpdateValue,
}) => {
  const {
    closeCountriesDrawer,
    containerRef,
    countryDrawerOpen,
    countryObjectToLocal,
    currentSlide,
    inputErrors,
    isSendingOtp,
    loaderRefs,
    loginVal,
    mediaRefs,
    mobileInputRef,
    navigateToLogin,
    nextSlide,
    onChange,
    onGenerateOtp,
    openCountriesDrawer,
    previousSlide,
    selectedCountry,
    setSelectedCountry,
  } = useSplashScreenPhone({
    onUpdateValue,
    slides: SPLASH_SCREENS,
  });

  return (
    <div className="splash-screen-phone" ref={containerRef}>
      <div className="splash-screen-phone-header">
        <img
          src={SVGS.ZotokLogo}
          alt=""
          className="splash-screen-phone-header-image"
        />
        <ZoButton
          onClick={navigateToLogin}
          label={'Login'}
          endIcon={
            <img
              src={SVGS.RightArrowBlue}
              alt=""
              width={15}
              height={13}
              className="navigate-right-icon"
            />
          }
          className="splash-screen-phone-header-button primary-font-semibold"
        />
      </div>
      <div className="splash-screen-phone-container">
        <div
          className="navigate-left"
          onClick={() => {
            previousSlide();
            console.log('test: previous slide clicked');
          }}
          style={currentSlide === 0 ? { visibility: 'hidden' } : {}}
        >
          <SVGS.RightArrowComponent
            fill="#000000"
            stroke="#000000"
            className="navigate-left-icon"
          />
        </div>
        <div
          className="splash-screen-slides-container"
          style={{ transform: `translateX(-${currentSlide * 20}%)` }}
        >
          {SPLASH_SCREENS.map((slide, index) => (
            <div
              className={`splash-screen-slide ${
                currentSlide === index ? 'active' : ''
              }`}
            >
              <div className="splash-screen-slide-content">
                <div
                  className="splash-screen-phone-body"
                  style={{ touchAction: 'none' }}
                >
                  <div className="loader-container">
                    <div
                      className="loader"
                      ref={(el) => (loaderRefs.current[index] = el)}
                    />
                  </div>
                  <img
                    ref={(el) => {
                      if (el) {
                        mediaRefs.current[index] = el;
                        el.onload = () => {
                          loaderRefs.current[index]?.classList.add('hidden');
                          el.classList.add('loaded');
                        };
                        el.onerror = () => {
                          loaderRefs.current[index]?.classList.add('hidden');
                        };
                      }
                    }}
                    src={slide.imageUrl}
                    alt=""
                    className="splash-screen-phone-body-image"
                  />
                </div>
                <div
                  className="splash-screen-phone-text"
                  style={{ touchAction: 'none' }}
                >
                  {slide.heading}
                  {slide.description}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div
          className="navigate-right"
          onClick={nextSlide}
          style={currentSlide === 4 ? { visibility: 'hidden' } : {}}
        >
          <SVGS.RightArrowComponent
            fill="#000000"
            stroke="#000000"
            className="navigate-right-icon"
          />
        </div>

        <div className="splash-screen-phone-footer">
          <div className="splash-screen-phone-footer-buttons">
            <div className="splash-screen-phone-footer-identifier">
              {[0, 1, 2, 3, 4].map((i) => (
                <span
                  key={i}
                  className="identifier-circle"
                  style={
                    currentSlide === i ? { backgroundColor: '#32A7E8' } : {}
                  }
                ></span>
              ))}
            </div>
            <div className="splash-screen-phone-footer-input">
              <div className="input-container" ref={mobileInputRef}>
                <ZoInputText
                  name=""
                  focusInput={true}
                  inputFieldProps={{
                    name: 'loginVal',
                    value: loginVal,
                    onChange: onChange,
                    maxLength: digitCounts[selectedCountry?.code],
                  }}
                  error={inputErrors?.isError}
                  onBlur={() => {}}
                  placeholder="Enter Mobile no"
                  startAdornment={
                    <span
                      onClick={() =>
                        countryDrawerOpen
                          ? closeCountriesDrawer()
                          : openCountriesDrawer()
                      }
                      className="input-dial-code"
                    >
                      {`${selectedCountry?.dial_code} (${selectedCountry?.code})`}{' '}
                      <img
                        src={SVGS.SelectArrowDown}
                        alt=""
                        width={15}
                        height={15}
                      />
                    </span>
                  }
                  containerStyles={{
                    backgroundColor: '#ffffff',
                    borderRadius: '6px',
                  }}
                />
                <SwipeableDrawer
                  open={countryDrawerOpen}
                  anchorRef={mobileInputRef}
                  openDrawer={openCountriesDrawer}
                  closeDrawer={closeCountriesDrawer}
                >
                  <CountriesList
                    closeCountriesDrawer={closeCountriesDrawer}
                    selectedCountry={selectedCountry}
                    setSelectedCountry={(country: CountryObject) => {
                      onUpdateValue('dial_code', selectedCountry?.dial_code);
                      setSelectedCountry(country);
                      countryObjectToLocal(country);
                    }}
                    showCountryCode={true}
                  />
                </SwipeableDrawer>
                <ZoButton
                  className="input-button"
                  label={''}
                  isLoading={isSendingOtp}
                  onClick={onGenerateOtp}
                  startIcon={<img src={SVGS.RightArrowIcon} alt="" />}
                />
              </div>
              {inputErrors?.isError && (
                <div className="splash-screen-phone-footer-error">
                  <img
                    src={SVGS.InputInfoError}
                    className="splash-screen-phone-footer-error-icon"
                    alt="Error icon"
                  />
                  <span className="splash-screen-phone-footer-error-text primary-font-regular">
                    {inputErrors?.errorMsg}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
